import { OEButton } from '@openeducation/oe-it-components';
import { useState } from 'react';

import { MessageTable } from './message-card-table';
import { MessageEmpty } from './message-empty';
import { Card } from '../../atoms/card/card';
import { MessageItem } from '../../interfaces/message-notification';
import { MessageComposeModal } from '../message-compose-modal/message-compose-modal';
import { MessageConfirmDeleteModal } from '../message-remove-confirm-modal/message-remove-confirm-modal';

export interface MessageCardProps {
  data?: MessageItem[];
  isLoading: boolean;
  onRemove: (id: string) => void;
  canCompose: boolean;
  onPagination: (page: number, itensPerPage: number) => void;
  pagination: { page: number; itemsPerPage: number };
}
export const MessageCard = ({
  data,
  isLoading,
  onRemove,
  canCompose,
  onPagination,
  pagination,
}: MessageCardProps) => {
  const [composeVisible, setComposeVisible] = useState(false);

  const [removeId, setRemoveId] = useState<string | null>(null);
  const handleRemove = async (id: string) => {
    onRemove(id);
    setRemoveId(null);
  };

  return (
    <Card
      title={`Inbox (${data?.length || 0})`}
      fullWidth
      rightContent={
        canCompose && (
          <OEButton onPress={() => setComposeVisible(true)}>Compose</OEButton>
        )
      }
    >
      {!isLoading && !data?.length ? (
        <MessageEmpty />
      ) : (
        <MessageTable
          onRemove={(id: string) => setRemoveId(id)}
          messages={data}
          isLoading={isLoading}
          onPagination={onPagination}
          pagination={pagination}
        />
      )}

      <MessageComposeModal
        visible={composeVisible}
        onClose={() => setComposeVisible(false)}
      />
      <MessageConfirmDeleteModal
        removeId={removeId}
        onRemoveConfirm={handleRemove}
        onCancel={() => setRemoveId(null)}
      />
    </Card>
  );
};
